module.exports = __webpack_public_path__ + "img/solution-apply.345c9a44.png";